<template>
    <div class="text-center text-secondary opacity-25" style="padding-top: 35vh;">
        <div class="spinner-border" style="width: 10vh; height: 10vh;" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Preloader"
}
</script>
